






























declare let bauminatorData:any;
import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {translate} from '@/services/trans'

@Component
export default class videoBuminator extends Vue {
  @Prop() isMobileView!: boolean;

  public vm_x = 0
  public vw_x = 0
  public textAnimationDelay = -15
  public enabledYoutubePlayer = false
  upAction = false
  downAction = true
  public scroll_position = 0
  public isYoutubeLink = false;

  mounted() {
    window.addEventListener('scroll', this.onScroll);
    this.isYoutubeLink = (bauminatorData && bauminatorData.youtubeLink.length>0  ) ? true : false;
  }


  trans(key: string) {
    return translate(key)
  }

  get videoId() {
    return this.getvideoId(bauminatorData.youtubeLink);
  }

  getvideoId(url:any){
        url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
    }

  onScroll(e: any) {
    if(this.isYoutubeLink){
      const element: any = document.getElementById('videoBuminator')
      const elementTopPosition = element.getBoundingClientRect().top
      const elementInnerHeight = element.clientHeight
      const pageYOffset = window.pageYOffset
      const innerHeight = window.innerHeight
      this.scroll_position = (elementTopPosition / (elementInnerHeight / 100)) * 1.8

      if(this.scroll_position < -100 && this.downAction){
        this.nextFrom('videoBuminator', false)
        this.downAction = false
        this.upAction = true
      }
      if(this.scroll_position > 20 && this.upAction){
        this.nextFrom('videoBuminator', true)
        this.downAction = true
        this.upAction = false
      }
    }
  }
  @Emit("next")
  nextFrom(name :string, isDown: boolean = false) {}

}
